import UserType from './userType';
import * as STRINGS from './strings';

const PASSCODE_FORMAT = /\d{9,12}/;

export { UserType, PASSCODE_FORMAT, STRINGS };

export const LOCATION = 'location';
